import React from "react";
import { Helmet } from "react-helmet-async";
import { siteMeta } from "@/lib/seo-config";

/**
 * SEO — sets per-page title, meta, canonical, OG, Twitter and optional JSON-LD.
 * Props:
 *  - title, description, path, keywords, ogImage
 *  - jsonLd?: object | object[]  (any additional schema for the page)
 */
export default function SEO({
    title,
    description,
    path = "/",
    keywords,
    ogImage,
    jsonLd,
    ogType = "website",
}) {
    const url = `${siteMeta.siteUrl}${path}`;
    const image = ogImage || siteMeta.ogImage;
    const schemas = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            {keywords && <meta name="keywords" content={keywords} />}
            <link rel="canonical" href={url} />

            {/* Open Graph */}
            <meta property="og:type" content={ogType} />
            <meta property="og:site_name" content={siteMeta.siteName} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={image} />
            <meta property="og:image:alt" content={title} />
            <meta property="og:locale" content="en_AE" />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {/* Robots */}
            <meta name="robots" content="index, follow, max-image-preview:large" />

            {/* JSON-LD */}
            {schemas.map((s, i) => (
                <script key={i} type="application/ld+json">{JSON.stringify(s)}</script>
            ))}
        </Helmet>
    );
}
